import { SET_SETTINGS } from "./types";

const initialState = {
  settings: {},
};

function reducer(state = initialState, action) {
  switch (action.type) {
    case SET_SETTINGS:
      return {
        ...state,
        settings: { ...state.settings, ...action.payload },
      };
    default:
      return state;
  }
}
export default reducer;
